import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

import Typography from '@shared/constants/Typography';

const CloseIcon: React.FC<Props> = ({
  width: _width = Typography.width.width44,
  height: _height = Typography.height.height40,
  color = '#000000',
}) => {
  return (
    <Svg
      width={_width}
      height={_height}
      viewBox="0 0 44 40"
      fill="none"
    >
      <Path
        d="M28 14L16 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16 14L28 26"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default CloseIcon;
